import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import 'chart.js/auto';
import { Pie } from "react-chartjs-2";
import { Link } from "react-router-dom";
import { Chart, ArcElement, LinearScale, TimeScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { getUserGrowthData } from "../shared/_services/common.services";
import Placeholder_Line_Chart from '../assets/images/Placeholder_Line_Chart.svg';
import Placeholder_Total_Asset_PieChart from '../assets/images/Placeholder_Total_Asset_PieChart.svg';
import Placeholder_Total_Debt_PieChart from '../assets/images/Placeholder_Total_Debt_PieChart.svg';

Chart.register(ArcElement, ChartDataLabels, LinearScale, TimeScale);

const DashboardCharts = ({ chartType, investmentData, oldInvestmentData, debtData, oldDebtData, popupShow, popupClose }) => {
    let timeout;
    const [options, setOptions] = React.useState(null);
    //     chart: {
    //       type: 'line'
    //     },
    //     title: {
    //       text: 'Assets over Time'
    //     },
    //     xAxis: {
    //       categories: categories,
    //       title: {
    //         text: 'Month'
    //       }
    //     },
    //     yAxis: {
    //       title: {
    //         text: 'Total Assets'
    //       }
    //     },
    //     series: [
    //       {
    //         name: 'Debt',
    //         data: debtDataNew
    //       },
    //       {
    //         name: 'Investment',
    //         data: investmentDataNew
    //       }
    //     ]
    //   };

    useEffect(() => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            getUserGrowth();
        }, 0);
    }, []);

    const calculatePercentageChange = (newValue, oldValue) => {
        if (oldValue === 0) {
            return newValue > 0 ? 100 : 0;
        }
        return ((newValue - oldValue) / oldValue) * 100;
    };

    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    
    
    const createdAt = currentUser?.user?.createdAt ? new Date(currentUser?.user?.createdAt) : null;
    const currentDate = new Date();
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(currentDate.getMonth() - 2);
    
    const isGraphVisible = createdAt && createdAt <= twoMonthsAgo;
    

    



    


    const pieChartOptions = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                align: 'start',
                labels: {
                    boxWidth: 15,
                    padding: 10,
                },
                fullSize: false,
            },
            tooltip: {
                enabled: true,
                callbacks: {
                    label: function (context) {
                        const index = context.dataIndex;
                        const value = context.dataset.data[index];
                        const oldValue = chartType === 'investment'
                            ? oldInvestmentData.datasets[0]?.data[index] || 0
                            : oldDebtData.datasets[0]?.data[index] || 0;

                        const percentageChange = calculatePercentageChange(value, oldValue);
                        let triangle;

                        if (percentageChange > 0) {
                            triangle = '▲';
                        } else if (percentageChange < 0) {
                            triangle = '▼';
                        } else {
                            triangle = '△';
                        }


                        return `${context.label}: $${value.toLocaleString()} ${triangle} (${percentageChange.toFixed(2)}%)`;
                    }
                }
            },
            datalabels: {
                display: false,
            }
        },
        layout: {
            padding: {
                top: 10,
            },
        },
        responsive: true,
    };

    async function getUserGrowth() {
    try {
        let res = await getUserGrowthData();
        const chartData = createHighchartsSeries(res?.data?.data);

        if (!chartData || !chartData.categories || !chartData.series) {
            console.warn("Invalid chart data returned from createHighchartsSeries", chartData);
            return;
        }

        const { categories, series } = chartData;

        const options = {
            chart: {
                type: 'area',
                height: 300
            },
            title: {
                text: 'Comparative Growth Analysis'
            },
            xAxis: {
                categories: categories,
                title: {
                    text: 'Month-Year'
                }
            },
            yAxis: {
                title: {
                    text: ''
                }
            },
            series: series.map(s => ({
                ...s,
                type: 'area',
                fillOpacity: 0.5
            }))
        };

        setOptions(options);
    } catch (error) {
    }
}

    function createHighchartsSeries(data) {
        // Extract unique yearMonth values for the x-axis
        const categories = Array.from(new Set(data.map(item => item.yearMonth)));

        // Format categories as month-year (e.g., 02-2025)
        const formattedCategories = categories.map(monthYear => {
            const [year, month] = monthYear.split("-");
            return `${year}-${month}`;
        });

        // do not show line chart if there is less than one month data
        if (formattedCategories.length < 2) return;

        // Initialize data arrays for debt, investment, and net worth
        const debtData = formattedCategories.map(yearMonth => {
            const entry = data.find(item => item.yearMonth === yearMonth && item.category === "debt");
            return entry ? entry.totalAssets : 0;
        });

        const investmentData = formattedCategories.map(yearMonth => {
            const entry = data.find(item => item.yearMonth === yearMonth && item.category === "investment");
            return entry ? entry.totalAssets : 0;
        });

        // Calculate net worth (investment - debt)
        const netWorthData = investmentData.map((investment, index) => investment - debtData[index]);

        // Return series data for Highcharts
        return {
            categories: formattedCategories,
            series: [
                {
                    name: 'Debt',
                    data: debtData
                },
                {
                    name: 'Assets',
                    data: investmentData
                },
                {
                    name: 'Net Worth',
                    data: netWorthData
                }
            ]
        };
    }

    return (
        <Modal
            size="lg"
            className={`pie-chart-dtl-popup ${chartType === "investment" ? "invAllocationPopup" : "debtPopup"}`}
            show={popupShow}
            onHide={popupClose}
            aria-labelledby={chartType === "investment" ? "invAllocationPopupLabel" : "debtPopupLabel"}
            backdrop="static"
            keyboard={false}
            centered
        >
            <div className="modal-body">
                <div className="d-flex justify-content-between">
                    <h4></h4>
                    <Link className="close-popup-btn" onClick={popupClose}>
                        <i className="fa fa-times"></i>
                    </Link>
                </div>
                <div className="pie-chart-content">
                    <div className="px-3 d-flex justify-content-around">
                        <div style={{ width: '48%', height: "360px" }}>
                            <h5 className="f-700" style={{ textAlign: 'left' }}>Total Assets</h5>
                            {investmentData?.datasets &&
                                investmentData.datasets[0]?.data &&
                                investmentData.datasets[0].data.length > 0 ? (
                                <Pie data={investmentData} options={pieChartOptions} />
                            ) : (
                                <div className="assets-pie-chart-placeholder">
                                    <img src={Placeholder_Total_Asset_PieChart} alt="" />
                                </div>
                            )}
                        </div>

                        <div style={{ width: '48%', height: "360px" }}>
                            <h5 className="f-700" style={{ textAlign: 'left' }}>Total Debt</h5>
                            {debtData?.datasets &&
                                debtData.datasets[0]?.data &&
                                debtData.datasets[0].data.length > 0 ? (
                                <Pie data={debtData} options={pieChartOptions} />
                            ) : (
                                <div className="debt-pie-chart-placeholder">
                                    <img src={Placeholder_Total_Debt_PieChart} alt="" />
                                </div>
                            )}
                        </div>
                    </div>
                    {
                        <>
                            {isGraphVisible && options ? (
                                <HighchartsReact highcharts={Highcharts} options={options} />
                            ) : (
                                <div className="line-chart-placeholder">
                                    <h5 className="f-700" style={{ textAlign: "left", paddingLeft: "18px", paddingTop: "20px" }}>
                                        Comparative Growth Analysis
                                    </h5>
                                    <img src={Placeholder_Line_Chart} alt="Placeholder Chart" />
                                    
                                </div>
                            )}
                        </>

                    }

                </div>
            </div>
        </Modal>
    );
};

export default DashboardCharts;